var _path, _path2, _path3, _path4, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1080",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1137.73 0H0L539.306 541.125L514.368 566.043H1137.73V0Z",
    fill: "#636363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M542.169 543.747L0.00249337 1080L0 0L542.169 543.747Z",
    fill: "url(#paint0_linear_2637_2281)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1081 0.000216694L1920 0.000168065L1920 341.368L1177.32 1080L0.000976562 1080L1081 0.000216694Z",
    fill: "url(#paint1_linear_2637_2281)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 1080L1171 1080L1920 334.053L1920 1080Z",
    fill: "url(#paint2_linear_2637_2281)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "background-rect",
    width: 1920,
    height: 1080,
    fill: "#56C2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2637_2281",
    x1: 271.011,
    y1: 810,
    x2: -187.934,
    y2: 349.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314876,
    stopColor: "#606060",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2637_2281",
    x1: 960.001,
    y1: 1080,
    x2: 1993.07,
    y2: 59.2047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.212502,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2637_2281",
    x1: 1805,
    y1: 932.813,
    x2: 1206.24,
    y2: 334.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#8B8B8B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.874c33a6d079ac9101859331cb70dca0.svg";
export { ForwardRef as ReactComponent };